import Status from './src/Status.vue'

Status.install = function (Vue) {
  Vue.component(Status.name, Status)
}

export default Status
